module.exports = __webpack_public_path__ + "img/23_54.cb6ddb95.png";